import Project from '@/classes/projects/Project'

export default class DefaultValues {
  constructor ({ project, ...values } = {}) {
    this.project = new Project(project)

    Object.assign(this, values)
  }

  get to_database () {
    return {
      ...this,
      project: this.project.to_database
    }
  }
}
